<template>
    <div class="video mb--small">
        <dreambroker-studio-video-player v-if="channelId && videoId" site="https://dreambroker.com" :resource="`${channelId}/${videoId}`" width="1280" height="720" ></dreambroker-studio-video-player>
    </div>
  </template>
  
  <script>
  export default {
    name: "DreamBroker",
    props: {
      video: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        channelId: "",
        videoId: "",
      };
    },
    beforeMount() {
      let videoUrl = this.video.replace("/iframe", "");
      // Fjern sidste / hvis der er en
      if (videoUrl.endsWith("/")) {
        videoUrl = videoUrl.slice(0, -1);
      }
  
      const parts = videoUrl.split("/");
  
      if (parts.length >= 5) {
        this.channelId = parts[4];
        this.videoId = parts[parts.length - 1];
      }
    },
  };
  </script>
  